import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DetectRouteService {
  private currentCompanyId$: BehaviorSubject<string> =
    new BehaviorSubject<string>('');

  private isReload = false;
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    // 偵測路由變動，取得路由上的 company id 設定
    // 提供呼叫 api 需傳送 company id 之需求
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route: ActivatedRoute) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route: ActivatedRoute) => route.outlet === 'primary')
      )
      .subscribe((route: ActivatedRoute) => {
        const companyId = route.snapshot.params.company || '';
        this.currentCompanyId$.next(companyId);
      });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd){
          this.isReload = (event.id === 1 && (event.url === event.urlAfterRedirects));
        }
      });
  }

  getCurrentRouteCompanyId(): string {
    return this.currentCompanyId$.value;
  }

  getIsReload(): boolean{
    return this.isReload;
  }
}
